import { get } from '../Services/http';
import { catchError } from './Error.action';
import { showLoader, hideLoader } from '../Actions/Loader.action';

export const STATEMENTS_RECEIVE = 'STATEMENTS_RECEIVE';
export const STATEMENTS_ERROR = 'STATEMENTS_ERROR';

export const receive = (data) => ({
    type: STATEMENTS_RECEIVE,
    payload: {
        list: data,
    },
});

export const setError = error => ({
    type: STATEMENTS_ERROR,
    payload: {
        error,
    },
});

export const query = () => (dispatch) => {
    dispatch(showLoader());
    return get('/api/erp/statements')
        .then(response => response.json())
        .then((result) => {
            dispatch(receive(result));
            dispatch(hideLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};
